import { FaArrowLeft, FaArrowRight } from "react-icons/fa";

/**
 * Shared, accessible arrow buttons for react-slick carousels.
 *
 * react-slick calls our component as a function with these props:
 *   - currentSlide, slideCount
 *   - className (includes slick-prev / slick-next and slick-disabled
 *     when at the edge)
 *   - onClick, style, etc. — we forward all the rest.
 */
const SlickArrow = ({ direction, currentSlide, slideCount, ...props }) => {
  const isPrev = direction === "prev";
  const Icon = isPrev ? FaArrowLeft : FaArrowRight;
  const disabled = isPrev
    ? currentSlide === 0
    : currentSlide === slideCount - 1;
  const baseClass = isPrev ? "slick-prev slick-arrow" : "slick-next slick-arrow";
  const className = `${baseClass}${disabled ? " slick-disabled" : ""}`;
  return (
    <button
      type="button"
      className={className}
      aria-disabled={disabled}
      aria-label={isPrev ? "Previous slide" : "Next slide"}
      {...props}
    >
      <Icon aria-hidden="true" />
    </button>
  );
};

export const SlickArrowLeft = (props) => <SlickArrow direction="prev" {...props} />;
export const SlickArrowRight = (props) => <SlickArrow direction="next" {...props} />;
export default SlickArrow;